import { MAX_FILES_COUNT } from "../../shared";
import MultipleFiles from "./MultipleFiles";
import SingleFile from "./SingleFile";
import { DropzoneProps } from "./types";

const Dropzone = ({
    supportedFormats,
    isDisabled,
    countCsv,
    tooltipText,
    isMultiple,
    maxFileNameLength,
    maxFiles,
    isLoading,
    isUploaded,
    maxSizeBytes
}: DropzoneProps) => {
    return isMultiple ? (
        <MultipleFiles
            supportedFormats={supportedFormats}
            isDisabled={isDisabled}
            maxFileNameLength={maxFileNameLength}
            maxFiles={maxFiles || MAX_FILES_COUNT}
            isLoading={isLoading}
            isUploaded={isUploaded}
            maxSizeBytes={maxSizeBytes}
        />
    ) : (
        <SingleFile
            supportedFormats={supportedFormats}
            isDisabled={isDisabled}
            maxFileNameLength={maxFileNameLength}
            isLoading={isLoading}
            countCsv={countCsv}
            tooltipText={tooltipText}
        />
    );
};

export default Dropzone;
